export const wrapTables = (domContainer: HTMLElement) => {
  Array.from(domContainer.querySelectorAll('table')).forEach((table) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('oc-tableContainer');
    table.parentNode?.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
};

export default { wrapTables };
